import { AxiosRequestConfig } from 'axios'

interface BaseHttp<P, R> {
  Execute(Params?: P, config?: AxiosRequestConfig): Promise<R>
  Cancel(): void
}

const DealWithHttp = <P, R, SR>(BH: BaseHttp<P, R>, Success: (Result: R) => SR) => {
  /**
   * 执行Http操作
   */
  const Execute = async (Params?: P, config?: AxiosRequestConfig): Promise<SR> => {
    const Result = await BH.Execute(Params, config)
    return Success(Result)
  }

  /**
   * 取消Http请求
   */
  const Cancel = () => {
    return BH.Cancel()
  }

  return { Execute, Cancel }
}
export default DealWithHttp
